/**
 * Service to manage sync time tracking and formatting
 * This helps reduce Firestore reads by caching the last known sync time
 */
export const syncTimeService = {
  // Store the last time we know a sync happened
  storeLastKnownSync: (timestamp: number) => {
    localStorage.setItem('lastKnownSyncTime', timestamp.toString());
  },

  // Get the last known sync time
  getLastKnownSync: (): number => {
    return parseInt(localStorage.getItem('lastKnownSyncTime') || '0', 10);
  },
  
  // Store the last time we checked for a sync
  storeLastSyncCheckTime: (timestamp: number) => {
    localStorage.setItem('lastSyncCheckTime', timestamp.toString());
  },
  
  // Get the last time we checked for a sync
  getLastSyncCheckTime: (): number => {
    return parseInt(localStorage.getItem('lastSyncCheckTime') || '0', 10);
  },
  
  // Format the last sync time for display
  formatLastSyncTime: (timestamp: number): string => {
    if (!timestamp) return 'Unknown';
    
    const date = new Date(timestamp);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  }
};
